

function setContentHeight() {
    if (isMobileResolution()) {
        //$(".SepetProducts").css("top", ($(".MainControlOuther .TopBarLinks").height() + $(".MainControlOuther .News").height()) + 1 + "px");
        //$(".SepetProducts").height($(window).height($(".MainControlOuther .SLI").height() + $(".MainControlOuther .News").height()));

        var footerHeigh = parseInt($("header .SLI").css("height").split("px")[0]);
        var sepetIconWidth = parseInt($(" #UserMenus .RightBasket a").css("height").split("px")[0]) / 100 * 50;
        $("header #UserMenus .RightBasket .SepetProducts").css("top", footerHeigh - 12 + "px");
        $("header #UserMenus .RightBasket .polygon").css("top", footerHeigh - 12 - sepetIconWidth + "px");
    }
}

function toggleMenusOperation(type) {
    if (type == "basket") {
        setContentHeight();

        //$("body").addClass("BasketDropped");
        $(".SepetProducts").toggleClass("open");

        if (!$(".SepetProducts").hasClass("open"))
            $("body").removeClass("BasketDropped");

        $("#UserAndBasket .polygon").toggleClass("open");

        if (!isMobileResolution()) {
            setTimeout(function () {
                $(".RightBasket .SepetProducts").removeClass("open");
                $(".RightBasket .polygon").removeClass("open");
            }, 3000);
        }

        $(".contentTopSpace > .AccountMenu").removeClass("open");
        $("body > .Mobilmenu").removeClass("open");
        $("#LeftWrapper .mobilFilterArea").removeClass("open");
    }
    else if (type == "account") {
        if (!isMobileResolution()) {
            $(".contentTopSpace > .AccountMenu").css("top", ($("header").height() + 1) + "px");
        }

        $("body").addClass("BasketDropped");
        $(".contentTopSpace > .AccountMenu").toggleClass("open");

        if (!$(".contentTopSpace > .AccountMenu").hasClass("open"))
            $("body").removeClass("BasketDropped");

        $(".SepetProducts").removeClass("open");
        $("body > .Mobilmenu").removeClass("open");
        $("#LeftWrapper .mobilFilterArea").removeClass("open");
    }
    else if (type == "mobileMenu") {
        $("body").addClass("BasketDropped");
        $("body > .Mobilmenu").toggleClass("open");

        if (!$("body > .Mobilmenu").hasClass("open"))
            $("body").removeClass("BasketDropped");

        $(".SepetProducts").removeClass("open");
        $(".contentTopSpace > .AccountMenu").removeClass("open");
        $("#LeftWrapper .mobilFilterArea").removeClass("open");
    }
    else if (type == "mobileFilter") {
        if (!isMobileResolution()) {
            $("#LeftWrapper .mobilFilterArea").css("top", ($("header").height() + 1) + "px");
            $("#LeftWrapper .mobilFilterArea").css("height", ($(window).height() - $("header").height()) + "px");
        }

        $("body").addClass("BasketDropped");
        $("#LeftWrapper .mobilFilterArea").toggleClass("open");

        if (!$("#LeftWrapper .mobilFilterArea").hasClass("open"))
            $("body").removeClass("BasketDropped");

        $(".SepetProducts").removeClass("open");
        $(".contentTopSpace > .AccountMenu").removeClass("open");
        $("body > .Mobilmenu").removeClass("open");
    }
    else {
        $(".SepetProducts").removeClass("open");
        $("body > .Mobilmenu").removeClass("open");
        $(".contentTopSpace > .AccountMenu").removeClass("open");
        $("#LeftWrapper .mobilFilterArea").removeClass("open");

        setTimeout(function () { // .3 sn animasyon süresi olduğu için
            $("#LeftWrapper .mobilFilterArea .FilterOption.FilterBoxes").removeClass("active");
        }, 300);


        $("body").removeClass("BasketDropped");
    }
}
// End Mini Basket Style

// Mini Basket Operations
function RemoveFromCardForMiniCard(id, langId, allRemove) {
    basketElement = $("#UserMenus .SepetProducts .BasketContainer");
    GenerateLocalLoading(basketElement, "show");

    $.ajax({
        type: 'get',
        url: getRequestRoute() + '/p/Cart/RemoveFromCart',
        data: 'id=' + id + "&langID=" + langId + allRemove,
        contentType: "application/json; charset=utf-8",
        dataType: 'json',
        async: true,
        success: function (dt) {
            if (dt.Sonuc == true) {
                GetSepetIcerik(function (dt) {
                    $("#UserMenus  #UserAndBasket").html(dt);
                    toggleMenusOperation("basket");
                    generateToolTip();
                    //setContentHeight();

                    GenerateLocalLoading(basketElement, "hide");
                });
            }
            else {
                SwalGenerate("error", dt.IslemSonucAciklama, "İşlemin Başarısız", "Kapat");
            }
        },
        error: function () {
            GenerateLocalLoading(basketElement, "hide");
        }
    });
}

function GetSepetIcerik(callback) {
    $.ajax({
        type: 'get',
        url: getRequestRoute() + "/p/Cart/GetSepetIcerik",
        data: "",
        async: true,
        cache: false,
        contentType: "application/json; charset=utf-8",
        dataType: 'text',
        success: function (dt) {
            //$("#UserAndBasket").html(dt);

            if ($("#LangSelectionNeed").length > 0) {
                ShowLangAreaForChange();
            }

            if ($("#WindowSizeNotSetted").length > 0) {
                SetWindowSize();
            }
            if ($(".SepetProducts .BasketContainer .CartTitle .basket-text").html() == "") {
                $(".SepetProducts .BasketContainer .CartTitle .basket-text").html("<span>Sepet</span>")
            }
            callback(dt);
        }
    });
}
// End Mini Basket Operations

// Product Detail
function AddToCard(param, callback) {
    $.ajax({
        type: 'GET',
        url: getRequestRoute() + "/p/Cart/AddToCart",
        data: param,
        dataType: 'json',
        async: true,
        success: function (dt) {
            if (dt.JsonRs != null && dt.JsonRs != undefined && dt.JsonRs != "") {
                window.dataLayer = window.dataLayer || [];
                dataLayer.push({
                    "event": "eec.add",
                    "ecommerce": {
                        "add": {
                            "actionField": {
                                "list": "Product Detail"
                            },
                            "products": [JSON.parse(dt.JsonRs)]
                        }
                    }
                });
            }

            callback(dt);
        }
    });
}
// Product Detail

// Combine
function AddCombineToBasket(basketButton, NormalText, data) {
    GenerateLocalLoading($(".ProductDetail.Combines"), "show");

    $.ajax({
        type: 'GET',
        url: getRequestRoute() + "/p/Cart/AddCombineToCart",
        data: data,
        dataType: 'json',
        async: true,
        success: function (dt) {
            basketButton.text(NormalText);

            if (dt.Sonuc == true) {
                GetSepetIcerik(function (dt) {
                    $("#UserAndBasket").html(dt);
                    generateToolTip();
                    toggleMenusOperation("basket");
                });
            }
            else {
                SwalGenerate("error", dt.IslemSonucAciklama, "İşlemin Başarısız", "Kapat");
            }

            GenerateLocalLoading($(".ProductDetail.Combines"), "hide");
        }
    });
}
// End Combine